import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function CTASection({ to = '/pricing', title, subtitle, buttonText = 'View Pricing' }) {
  const handleClick = () => {
    if (window.gtag && to === '/pricing') {
      window.gtag('event', 'pricing_view', { source: 'cta_section' });
    }
  };

  return (
    <Box sx={{ py: 8, bgcolor: 'grey.50' }}>
      <Container maxWidth="md">
        <Paper
          elevation={4}
          sx={{
            p: 6,
            textAlign: 'center',
            background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
            color: 'white',
          }}
        >
          <Typography
            variant="h3"
            component="h2"
            gutterBottom
            sx={{ fontWeight: 700 }}
          >
            {title || 'Ready to Get Started?'}
          </Typography>

          <Typography
            variant="h6"
            sx={{ mb: 4, opacity: 0.95 }}
          >
            {subtitle || 'Start with 60 free minutes. No credit card required.'}
          </Typography>

          <Button
            component={RouterLink}
            to={to}
            variant="contained"
            size="large"
            color="secondary"
            endIcon={<ArrowForwardIcon />}
            onClick={handleClick}
            sx={{
              px: 5,
              py: 2,
              fontSize: '1.1rem',
              fontWeight: 600,
            }}
          >
            {buttonText}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}
